import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { fetchAllModules } from '../../requests/learning';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Wrapper,
  ArticleImage,
  BottomSection,
  ArticleTitle,
  ArticleScore,
  Title,
} from './Learning.styled';

const Cards = styled.div`
  margin-bottom: 87px;
  padding: 25px 20px;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`;

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 25px;
`;

const Card = ({ itemData, cardNavigatePath, showScores }) => {
  const navigate = useNavigate();
  const scoreHundredVersion = Math.floor(itemData.bestScore * 100);
  return (
    <Wrapper
      className="item"
      onClick={() => {
        navigate(`${cardNavigatePath}/${itemData.id}`);
      }}
    >
      <ArticleImage>
        <img src={itemData.pictureUrl} />
      </ArticleImage>
      <BottomSection>
        <ArticleTitle>{itemData.label}</ArticleTitle>
        {itemData.bestScore !== null && showScores && (
          <ArticleScore>
            <div className="score-title">BEST SCORE</div>
            <div
              className={`score-body ${
                scoreHundredVersion > 79
                  ? 'green'
                  : scoreHundredVersion > 59
                    ? 'yellow'
                    : 'red'
              }`}
            >
              {scoreHundredVersion}.0%
            </div>
          </ArticleScore>
        )}
      </BottomSection>
    </Wrapper>
  );
};

const LQATraining = () => {
  const [moduleName, setModuleName] = useState<any>('');
  const [modules, setModules] = useState<any>([]);
  const { t } = useTranslation();
  useEffect(() => {
    (async () => {
      const data = await fetchAllModules();
      const filteredData = data.filter(
        (module: { name: string }) => module.name === 'EI Guest Connection'
      );
      setModuleName(filteredData[0].name);
      setModules(filteredData[0].modules);
    })();
  }, []);

  return (
    <>
      <div className="header">
        <AppHeader
          title={t('COMMON.LEARNING.TITLES.LQA_EI_TRAINING')}
          hasBackButton={true}
        />
      </div>
      <Cards>
        <Title>
          {moduleName} ({modules.length})
        </Title>
        <Content>
          {modules === 0 ? (
            <LoadingContent layout="flex" />
          ) : (
            modules.map((item, i) => {
              const suggestions = [
                modules[(i + 1) % modules.length], // Usa o array correto
                modules[(i + 2) % modules.length],
              ];

              return (
                <Card
                  key={item.id}
                  itemData={{ ...item, moduleName, suggestions }}
                  cardNavigatePath="/learning/watch-video"
                  showScores={false}
                />
              );
            })
          )}
        </Content>
      </Cards>
    </>
  );
};

export default LQATraining;
